/**
 * Normalizes staff role.permissions from API or persisted session (array or JSON string).
 */
export function normalizeStaffPermissionList(raw: unknown): string[] {
  if (Array.isArray(raw)) {
    return raw as string[]
  }
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw) as unknown
      return Array.isArray(parsed) ? (parsed as string[]) : []
    } catch {
      return []
    }
  }
  return []
}

export function effectiveStaffPermissionList(
  rolePermissions: unknown,
  memberships: StaffVendorMembership[] | null | undefined,
  vendorIds?: number[],
): string[] {
  const permissions = new Set(normalizeStaffPermissionList(rolePermissions))
  const allowedVendorIds = vendorIds ? new Set(vendorIds.map(Number)) : null
  for (const membership of memberships ?? []) {
    if (membership.status !== 'active') continue
    if (allowedVendorIds && !allowedVendorIds.has(Number(membership.vendorId))) continue
    for (const permission of normalizeStaffPermissionList(membership.permissions)) permissions.add(permission)
  }
  return [...permissions]
}
import type { StaffVendorMembership } from '@/types/staff-user'
